// 9fbef606107a605d69c0edbcd8029e5d
import isEmpty from 'lodash/isEmpty';
import { css } from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';
import {
  THANKYOU_ICON_FILL_COLOUR,
  NAVBAR_SEMICIRCLE_FILL_COLOUR,
  NAVBAR_SEMICIRCLE_FILL_COLOUR_HOVER,
  NAVBAR_SEMICIRCLE_FILL_OPACITY,
} from '@tcp/core/src/constants/brandSpecific.constants';

const getOverrideColorStyle = (props, defaultColor) => {
  return !isEmpty(props.brandThemeColor) ? props.brandThemeColor.color : defaultColor;
};

export default css`
  padding: ${(props) => (props.shouldRenderMobileNavRedesignedView ? '0' : '0 14px')};

  ${(props) => (props.isShowNavAnimation ? 'flex-grow: 1;' : '')}

  @keyframes slide-in-nav {
    0% {
      display: none;
      opacity: 0;
      transform: scaleY(1);
    }
    1% {
      display: block;
    }
    99% {
      display: block;
    }
    100% {
      display: block;
      opacity: 1;
      transform: scaleY(1);
    }
  }
  @media ${(props) => props.theme.mediaQuery.large} {
    border-bottom: 3px solid transparent;
  }

  &.is-open {
    /* background: ${(props) => props.theme.colorPalette.gray[300]}; */
  }

  span {
    display: inline-block;
  }
  .nav-bar-l1-content {
    display: flex;
    padding: ${(props) => (props.shouldRenderMobileNavRedesignedView ? '0' : '18px 0 17px 0')};
    outline: 0;
    @media ${(props) => props.theme.mediaQuery.large} {
      text-align: center;
      ${(props) => props.isNewNavigationImagesEnabled && `max-width: 120px;height: 36px;`}
    }

    .category-size-range {
      color: ${(props) =>
        getOverrideColorStyle(props, THANKYOU_ICON_FILL_COLOUR[props?.brandId?.toUpperCase()])};
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
        font-size: 11px;
        min-height: 13px;
        color: ${(props) => getOverrideColorStyle(props, '#595959')};
        font-weight: 400;
        font-family: Nunito;
      }
    }
  }

  .icon-arrow {
    background: url(${(props) => getIconPath('icon-carrot-black-small', props)}) no-repeat;
    width: 10px;
    height: 10px;
    right: 8px;
    position: absolute;
    @media ${(props) => props.theme.mediaQuery.large} {
      display: none;
    }
  }
  .sizes-range-background {
    display: block;
    @media ${(props) => props.theme.mediaQuery.large} {
      ${(props) => props.isNewNavigationImagesEnabled && 'display: none;'}
    }
  }
  .images-row-wrapper {
    position: relative;
    overflow-y: hidden;
    text-align: center;
    margin: 0 auto;
    width: 106px;
    height: 108px;
    top: 3px;
  }
  .bg {
    position: absolute;
    top: 54px;
    height: 112px;
    border-radius: 100% 100% 0 0;
    background-color: ${(props) => NAVBAR_SEMICIRCLE_FILL_COLOUR[props?.brandId?.toUpperCase()]};
    opacity: ${(props) => NAVBAR_SEMICIRCLE_FILL_OPACITY[props?.brandId?.toUpperCase()]};
    margin: 0 auto;
    left: 0;
    right: 0;
  }
  .new-bg {
    background-color: ${(props) =>
      NAVBAR_SEMICIRCLE_FILL_COLOUR_HOVER[props?.brandId?.toUpperCase()]};
    opacity: 1;
  }
  .image-item,
  .image-item-blank {
    position: relative;
    min-height: 108px;
  }
  .nav-bar-item-label {
    width: 45%;
    cursor: pointer;
    font-weight: ${(props) => props.theme.fonts.fontWeight.medium};

    @media ${(props) => props.theme.mediaQuery.large} {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    &.highlighted {
      color: ${(props) => props.theme.colorPalette.secondary.main};
    }
    &.full-width {
      width: 96%;
    }
  }
  .nav-bar-item-label.l1-menu {
    white-space: unset;
  }
  .nav-bar-item-content {
    width: 51%;
    color: ${(props) => props.theme.colorPalette.primary.dark};
  }

  @media ${(props) => props.theme.mediaQuery.smallOnly} {
    &.nav-bar-l1-item.nav-bar-l1-item-mobile-redesign {
      .nav-bar-item-label-mobile-redesign.l1-menu.mobile-auto-width {
        width: auto;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumOnly} {
    &.nav-bar-l1-item.nav-bar-l1-item-mobile-redesign {
      .nav-bar-item-label-mobile-redesign.l1-menu.tablet-desktop-auto-width {
        width: auto;
      }
    }
  }
  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .nav-bar-item-label.l1-menu {
      ${(props) =>
        props.isNewNavigationImagesEnabled &&
        `
        text-transform: uppercase;
        font-size:10px;
        font-weight: ${props.theme.fonts.fontWeight.bold};
        line-height: 20px;
        color: ${props.theme.colors.BLACK};
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;`}
    }
    .nav-bar-item-label.l1-menu.snjFont {
      ${(props) =>
        props.isNewNavigationImagesEnabled &&
        `
        font-size:10px;
        `}
    }
    .images-row-wrapper {
      ${(props) =>
        props.isNewNavigationImagesEnabled &&
        `margin:auto
        `}
    }
    .nav-bar-l1-content {
      ${(props) =>
        props.isNewNavigationImagesEnabled &&
        `display: block;
        text-align: center;
        padding: 7px 0 0 0;
      `}
    }
    .nav-bar-l1-content .category-size-range {
      ${(props) =>
        props.isNewNavigationImagesEnabled &&
        ` font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        color: #494949;
        margin-top: -3.45px;
        `}
    }
    .nav-bar-l1-content .icon-arrow {
      ${(props) => props.isNewNavigationImagesEnabled && 'display: none'}
    }

    &.nav-bar-l1-item.nav-bar-l1-item-mobile-redesign {
      padding: 0;
      box-sizing: border-box;
      border-bottom: 1px solid #e3e3e3;

      &:last-child {
        border-bottom: none;
      }

      .icon-arrow {
        position: unset;
        background: url(${(props) => getIconPath('chevron-right', props)}) no-repeat;
        width: 20px;
        min-width: 20px;
        height: 20px;
        margin-left: auto;
      }

      .icon-arrow.hide-arrow {
        display: none;
      }

      .nav-bar-l1-content {
        align-items: center;
        justify-content: initial;
        column-gap: 16px;
        padding: 24px 16px;
      }

      .nav-bar-item-content {
        width: auto;
      }

      .nav-bar-item-label-mobile-redesign.l1-menu {
        color: #000;
        font-family: Nunito;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        letter-spacing: 0.16px;
        text-transform: capitalize;
        width: 50%;
        min-width: 50%;
        cursor: pointer;
      }

      .nav-bar-item-label-mobile-redesign.l1-menu.highlighted {
        color: #c8102e;
      }

      .nav-bar-item-label-mobile-redesign.l1-menu.auto-width {
        width: auto;
      }

      .category-size-range,
      .nav-bar-l1-promo-badge {
        font-family: Nunito;
        font-size: 10px;
        font-style: normal;
        font-weight: 700;
        line-height: 150%;
        letter-spacing: 0.1px;
        text-transform: capitalize;
        padding: 0;
      }

      .category-size-range {
        color: #595959;
      }
      .nav-bar-l1-promo-badge {
        color: #c8102e;
        background: transparent;
      }
    }
    &.nav-bar-l1-item.nav-bar-l1-item-mobile-redesign.grouped-l1-item {
      border-bottom: none;

      .nav-bar-l1-content {
        padding: 0;
      }

      .nav-bar-item-label-mobile-redesign.l1-menu {
        font-weight: 400;
        letter-spacing: unset;
      }
    }
  }

  @media ${(props) => props.theme.mediaQuery.large} {
    padding: 0;
    color: ${(props) => props.theme.colorPalette.text.primary};
    span {
      display: inline;
    }
    .nav-bar-item-content,
    &.show-on-mobile {
      display: none;
    }
    .nav-bar-l1-content {
      display: block;
      cursor: pointer;
      position: relative;
      padding: 18px 0px 5px 0px;
      @media ${(props) => props.theme.mediaQuery.large} {
        text-align: center;
      }
    }
    .nav-bar-item-label {
      width: 100%;
      display: inline-block;
    }
    .nav-bar-item-label.l1-menu {
      ${(props) => `text-transform: uppercase;
        font-size:14px;
        font-weight: ${props.theme.fonts.fontWeight.bold};
      `}
      @media ${(props) => props.theme.mediaQuery.large} {
        font-size: 13px;
      }
    }
    &.l1-overlay.is-open {
      background: ${(props) => props.theme.colorPalette.gray[900]};
      position: absolute;
      ${(props) => (!props.isNewNavigationImagesEnabled ? `top: 75px;` : 'top: 170px;')}
      z-index: 1;
      opacity: 0.6;
      width: 100%;
      left: 0%;
      height: 200vh;
    }
    &.is-open {
      background: none;
      color: ${(props) => props.theme.colorPalette.text.primary};
      ${(props) =>
        !props.isNewNavigationImagesEnabled
          ? `border-bottom: 3px solid ${getOverrideColorStyle(
              props,
              props.theme.colorPalette.primary.main
            )}`
          : ``};
      ${(props) =>
        props.isNewNavigationImagesEnabled && props.showCondensedHeader
          ? `border-bottom: 3px solid ${props.theme.colorPalette.primary.main};`
          : ''};
      .nav-bar-l2 {
        ${(props) =>
          props.isShowNavAnimation ? 'animation: slide-in-nav 250ms forwards;' : 'display: block;'}
      }
      .nav-bar-item-sizes-range {
        cursor: default;
        position: absolute;
        display: block;
        top: calc(100% + 15px);
        left: 0;
        width: 100%;
        color: ${(props) => props.theme.colorPalette.gray[900]};
        text-align: center;
        font-weight: 600;
        z-index: ${(props) => props.theme.zindex.zDrawer + 1};
        white-space: nowrap;
      }
    }
  }
  .show-child {
    display: block;
  }
  .hide-child {
    display: none;
  }
`;
